import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  NewspaperIcon,
  ShoppingBagIcon,
  FolderIcon,
  SwatchIcon,
  PhotoIcon,
} from '@heroicons/react/24/outline';
import { getDashboardStats } from '../../lib/api';

const Dashboard = () => {
  const [stats, setStats] = useState({
    blogCount: 0,
    productCount: 0,
    projectCount: 0,
    colorCount: 0,
    galleryCount: 0,
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const data = await getDashboardStats();
      setStats({
        blogCount: data.blogCount || 0,
        productCount: data.productCount || 0,
        projectCount: data.projectCount || 0,
        colorCount: data.colorCount || 0,
        galleryCount: data.galleryCount || 0,
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
        <Link
          to="/admin/blogs"
          className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center justify-between mb-2">
            <NewspaperIcon className="h-8 w-8 text-gray-500" />
            <span className="text-2xl font-bold">{stats.blogCount}</span>
          </div>
          <h3 className="text-lg font-medium text-gray-900">Blog Yazıları</h3>
          <p className="text-sm text-gray-600 mt-1">Tüm blog yazılarını görüntüle</p>
        </Link>

        <Link
          to="/admin/products"
          className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center justify-between mb-2">
            <ShoppingBagIcon className="h-8 w-8 text-gray-500" />
            <span className="text-2xl font-bold">{stats.productCount}</span>
          </div>
          <h3 className="text-lg font-medium text-gray-900">Ürünler</h3>
          <p className="text-sm text-gray-600 mt-1">Tüm ürünleri görüntüle</p>
        </Link>

        <Link
          to="/admin/projects"
          className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center justify-between mb-2">
            <FolderIcon className="h-8 w-8 text-gray-500" />
            <span className="text-2xl font-bold">{stats.projectCount}</span>
          </div>
          <h3 className="text-lg font-medium text-gray-900">Projeler</h3>
          <p className="text-sm text-gray-600 mt-1">Tüm projeleri görüntüle</p>
        </Link>

        <Link
          to="/admin/gallery"
          className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center justify-between mb-2">
            <PhotoIcon className="h-8 w-8 text-gray-500" />
            <span className="text-2xl font-bold">{stats.galleryCount}</span>
          </div>
          <h3 className="text-lg font-medium text-gray-900">Galeri</h3>
          <p className="text-sm text-gray-600 mt-1">Tüm galeri öğelerini görüntüle</p>
        </Link>

        <Link
          to="/admin/colors"
          className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center justify-between mb-2">
            <SwatchIcon className="h-8 w-8 text-gray-500" />
            <span className="text-2xl font-bold">{stats.colorCount}</span>
          </div>
          <h3 className="text-lg font-medium text-gray-900">Renkler</h3>
          <p className="text-sm text-gray-600 mt-1">Tüm renkleri görüntüle</p>
        </Link>
      </div>
    </div>
  );
};

export default Dashboard;
